import 'bootstrap/dist/css/bootstrap.min.css';
import './tsr-order.css';

function TsrOrderLayout({ children }) {
  return (
    <div className="tsr-order-app">
      {children}
    </div>
  );
}

export default TsrOrderLayout;
